var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "list-root" }, [
    _c("div", { staticClass: "title" }, [
      _c("div", { staticClass: "edit-column" }, [
        _c("div", [
          _vm._v(_vm._s(_vm.$t("characterPage.characterFolderList.folder"))),
        ]),
        _vm.isInsert
          ? _c(
              "div",
              { staticClass: "sorting", on: { click: _vm.completeSetFolder } },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t("characterPage.characterFolderList.moveButton")
                    ) +
                    " "
                ),
              ]
            )
          : _c(
              "div",
              {
                staticClass: "sorting",
                on: {
                  click: function ($event) {
                    return _vm.switchEditMode()
                  },
                },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.isEditMode
                        ? _vm.$t("characterPage.characterFolderList.saveButton")
                        : _vm.$t("characterPage.characterFolderList.sortButton")
                    ) +
                    " "
                ),
              ]
            ),
      ]),
    ]),
    _vm.items
      ? _c(
          "div",
          { staticClass: "list" },
          [
            !_vm.isInsert && !_vm.isEditMode
              ? _c("list-folder-item", {
                  attrs: {
                    label: _vm.$t(
                      "characterPage.characterFolderList.allCharacters"
                    ),
                    count: _vm.charactersCount,
                    onSelectCallback: () => _vm.selectFolder(),
                    disabledMenu: true,
                  },
                })
              : _vm._e(),
            _vm.isInsert
              ? _c("div", { staticClass: "folder-select-description" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(
                          "characterPage.characterFolderList.selectFolderDescription"
                        )
                      ) +
                      " "
                  ),
                ])
              : _vm._e(),
            _c("sortable-list", {
              staticClass: "list-container",
              attrs: {
                items: _vm.folders,
                keyAttr: "characterFolderId",
                disabled: !_vm.isEditMode,
                extra: _vm.isEditMode,
              },
              on: {
                "update:items": function ($event) {
                  _vm.folders = $event
                },
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function ({ item, extra }) {
                      return [
                        _c("list-folder-item", {
                          attrs: {
                            label: item.name,
                            count: item.characterKeys.length,
                            isSorting: extra,
                            isSelecting: _vm.isInsert,
                            onSelectCallback: () =>
                              _vm.selectFolder(item.characterFolderId),
                            isChecked: _vm.isSelectedFolder(
                              item.characterFolderId
                            ),
                            onCheckCallback: () =>
                              _vm.onToggleInsertFolder(item.characterFolderId),
                            onRenameCallback: () =>
                              _vm.renameCharacterFolder(item.characterFolderId),
                            onDeleteCallback: () =>
                              _vm.deleteCharacterFolder(item.characterFolderId),
                          },
                        }),
                      ]
                    },
                  },
                ],
                null,
                false,
                3646719117
              ),
            }),
          ],
          1
        )
      : _vm._e(),
    _c(
      "button",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.isEditMode && !_vm.isInsert,
            expression: "!isEditMode && !isInsert",
          },
        ],
        staticClass: "create",
        on: { click: _vm.createCharacterFolder },
      },
      [
        _vm._v(
          " " +
            _vm._s(
              _vm.$t("characterPage.characterFolderList.createNewFolder")
            ) +
            " "
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }